module.exports = __webpack_public_path__ + "b0c19ec7fd4268f25842aeb0f19ce3bc.pdf";